function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "rotate(135.001 -142.425 -15.397) scale(.15641)",
  id: "t",
  href: "#k"
}), /*#__PURE__*/React.createElement("pattern", {
  id: "k",
  patternTransform: "translate(-254.024 74.426)",
  height: 110.741,
  width: 108.618,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  transform: "translate(1070.355 -11.764)",
  fill: "#00427f"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(30 -588.091 2050.257)",
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  fill: "#00427f"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(1124.664 -11.764)",
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  fill: "#00427f"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(30 -560.936 2151.6)",
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  fill: "#00427f"
})), /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "scale(.15023) rotate(-45 922.96 6085.23)",
  id: "l",
  href: "#m"
}), /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "scale(.15023) rotate(-45 -2473.244 6852.978)",
  id: "m",
  href: "#n"
}), /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "scale(.15023) rotate(-45 227.657 -29.145)",
  id: "n",
  href: "#o"
}), /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "scale(.15023) rotate(-45 730.249 525.163)",
  id: "o",
  href: "#p"
}), /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "scale(.15023) rotate(-45 47.044 -1811.87)",
  id: "p",
  href: "#q"
}), /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "matrix(.0652 -.0652 .0652 .0652 194.547 -74.73)",
  id: "q",
  href: "#r"
}), /*#__PURE__*/React.createElement("pattern", {
  patternTransform: "scale(.15565) rotate(-45 -238.81 2209.061)",
  id: "r",
  href: "#s"
}), /*#__PURE__*/React.createElement("pattern", {
  id: "s",
  patternTransform: "translate(-254.024 74.426)",
  height: 110.741,
  width: 108.618,
  patternUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  transform: "translate(1070.355 -11.764)",
  fill: "#d40000"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(30 -588.091 2050.257)",
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  fill: "#d40000"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(1124.664 -11.764)",
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  fill: "#d40000"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(30 -560.936 2151.6)",
  d: "M-1016.046 25.72l-10.764 16.121 7.177 18.006-18.658-5.255-14.907 12.39-.767-19.369-16.39-10.349 18.184-6.714 4.777-18.786 12.005 15.218z",
  fill: "#d40000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(259.614 -501.316)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 222.228,
  height: 310.811,
  x: -259.114,
  y: 501.816,
  ry: 10.63,
  rx: 10.63,
  fill: "#fff",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("rect", {
  width: 197.052,
  height: 286.644,
  x: -246.526,
  y: 513.9,
  ry: 0,
  fill: "none",
  stroke: "#00427f",
  strokeWidth: 4.952,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#t)",
  stroke: "#00427f",
  strokeLinecap: "round",
  d: "M-242.139 517.769h188.277v278.906h-188.277z"
}));

function SvgBlueBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.228,
    height: 311.811,
    viewBox: "0 0 223.228 311.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBack);
export default __webpack_public_path__ + "static/media/BLUE_BACK.ea1e6aa0.svg";
export { ForwardRef as ReactComponent };